<div class="ipm-share-container ">
    <div class="ipm-heading-model-section">
        <h3>
            <ng-container *ngIf="shareData.type === 'beat' || shareData.type === 'soundKit'; else artistType;">
                Share {{shareData.type === 'beat' ? 'Beat ': 'Sound Kit'}}
            </ng-container>
            <ng-template #artistType>
                Share {{shareData.type === 'playlist' ? 'PlayList ': 'Artist'}}
               
            </ng-template>
        </h3>
        <div class="ipm-close-icon" (click)="closeDialog()">
            <i class="pi pi-times"></i>
        </div>
    </div>
    <div class="ipm-share-body-container">
        <div class="copy-box">
            <input type="text" class="form-control copy-input linkPopup" [(ngModel)]='shareData.link'  #trackInfo readonly> 
            <button class="btn copy-button" (click)="copyInputMessage(trackInfo)"><i class="las la-copy"></i>Copy</button>
        </div>
        <div class="border-line-text">
            Or
        </div>
        <div class="social-share-section">
            <share-buttons theme="circles-dark"
            [include]="['facebook','twitter','whatsapp']"
            [showIcon]="true"
            [showText]="false"
            url="{{shareData.link}}">
            </share-buttons>
        </div>
    </div>
</div>